import {COMMANDS} from './attributeActionConstants'

const generateLabel = function (lastMove) {
  let move = 'A move was made'
  switch (lastMove.command) {
    case COMMANDS.ADD_ATTRIBUTE:
      move = '"' + lastMove.data.parent + ' - ' + lastMove.data.name + '" was added.'
      break
    case COMMANDS.REMOVED_ATTRIBUTE:
      if (lastMove.data.length > 0) {
        move = ''
        lastMove.data.forEach(data => {
          move += '"' + data[0].parent + ' - ' + data[0].name + '" was removed. '
        })
      } else {
        move = 'An attribute was removed.'
      }
      break
    case COMMANDS.CHANGED_OPERATOR:
      move = 'A operator was changed.'
      break
    case COMMANDS.GROUPED_ATTRIBUTES:
      move = 'You grouped attributes together.'
      break
    case COMMANDS.UNGROUPED_ATTRIBUTES:
      move = 'You ungrouped attributes.'
      break
    case COMMANDS.CHANGED_DATE:
      move = 'You changed the date.'
      break
  }
  return move
}

export default generateLabel



// WEBPACK FOOTER //
// ./src/app/appLogic/targetDefinition/LabelMoveGenerator.js